exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-bottom-text[data-v-3c39da3b]{width:100%;text-align:center;background:#1b2c61;color:#fff;padding-bottom:6px;padding-top:2px}.to-top[data-v-3c39da3b]{position:fixed;bottom:2%;right:1%;height:64px;width:64px;background:#1b2c61;-webkit-box-shadow:2px 2px 5px rgba(0,0,0,.3);box-shadow:2px 2px 5px rgba(0,0,0,.3);border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.to-top>img[data-v-3c39da3b]{height:50px;width:50px}.campany-link[data-v-3c39da3b]{color:#fff;border-bottom:thin solid #fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c39da3b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PrivacyPolicy/PrivacyPolicyBody.vue
// module id = jtX7
// module chunks = 3